import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './Login';
import Register from './Register';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';
import RecoverUsername from './RecoverUsername';
import ProtectedRoute from './ProtectedRoute';
import { isAuthenticated } from './Auth';
import Header from './components/Header';
import "./App.css"
import Library from './components/Library';
import UploadPhotos from './components/UploadPhotos';
import Indexing from './components/Indexing';
import ItemDetails from './components/ItemDetails';
import Settings from './components/Settings';
import Inbox from './components/Inbox';
import Profile from './components/Profile';
import SocialLibrary from './components/SocialLibrary';
import rolodexLogo from './assets/rolodex.webp';
import { accountRecoveryEnabled } from './features';
import { clearCachedProfile } from './profileCache';

function App() {
  const [loggedIn, setLoggedIn] = useState(isAuthenticated());

  useEffect(() => {
    document.title = 'Digidex';
    const favicon = document.querySelector('link[rel~="icon"]');
    if (favicon) {
      favicon.href = rolodexLogo;
      favicon.type = 'image/webp';
    }
  }, []);

  const handleLogin = () => {
    setLoggedIn(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    clearCachedProfile();
    setLoggedIn(false);
  };

  return (
    <Router>
      {loggedIn && <Header onLogout={handleLogout} />}
      <Routes>
        <Route
          path="/login"
          element={
            loggedIn ? <Navigate to="/" replace /> : <Login onLogin={handleLogin} />
          }
        />
        <Route path="/register" element={loggedIn ? <Navigate to="/" replace /> : <Register />} />
        <Route path="/forgot-password" element={loggedIn ? <Navigate to="/" replace /> : (accountRecoveryEnabled ? <ForgotPassword /> : <Navigate to="/login" replace />)} />
        <Route path="/reset-password" element={loggedIn ? <Navigate to="/" replace /> : (accountRecoveryEnabled ? <ResetPassword /> : <Navigate to="/login" replace />)} />
        <Route path="/recover-username" element={loggedIn ? <Navigate to="/" replace /> : (accountRecoveryEnabled ? <RecoverUsername /> : <Navigate to="/login" replace />)} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Library />
            </ProtectedRoute>
          }
        />
        <Route
          path="/upload-photos"
          element={
            <ProtectedRoute>
              <UploadPhotos />
            </ProtectedRoute>
          }
        />
        <Route
          path="/indexing"
          element={
            <ProtectedRoute>
              <Indexing />
            </ProtectedRoute>
          }
        />
        <Route
          path="/items/:id"
          element={
            <ProtectedRoute>
              <ItemDetails />
            </ProtectedRoute>
          }
        />
        <Route path="/social/users/:ownerId/items/:id" element={<ProtectedRoute><ItemDetails /></ProtectedRoute>} />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          }
        />
        <Route path="/digipals" element={<ProtectedRoute><Library initialScope="digipals" /></ProtectedRoute>} />
        <Route path="/inbox" element={<ProtectedRoute><Inbox /></ProtectedRoute>} />
        <Route path="/profiles/:id" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path="/social" element={<ProtectedRoute><SocialLibrary /></ProtectedRoute>} />
        {/* Add more protected routes as needed */}
      </Routes>
    </Router>
  );
}

export default App;
